<template>
  <div class="assign-list">
    <!-- Default Assignment Item -->
    <slot name="AssignmentItem"></slot>
  </div>
</template>

<script>
export default {
  name: "AssignmentList",
  components: {},
  props: {
    pages: Array,
    assigns: Array,
    type: String
  },
  data() {
    return {};
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.assign-list {
  .assign-item {
    @include trans-all;
    background: $neutral5;
    border-radius: 10px;
    margin-bottom: 10px;
    min-height: 90px;
    justify-content: center;

    &:hover {
      @include trans-all;
      box-shadow: 0px 7px 64px rgba(0, 24, 46, 0.15);
    }
    .avatar {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: auto;
      }
      svg {
        max-width: 100%;
      }
    }
    .select-options {
      width: 100%;
      .fake-select-option {
        ::v-deep .select {
          width: 100%;
          font-weight: inherit;
          flex-direction: row;
          justify-content: space-between;
          background: $neutral5;
          border-radius: 5px;
          border: 1px solid $grey3;
        }
        ::v-deep .gp_dropdown_list {
          max-height: 30vh;
          overflow: auto;
        }
      }
    }
    .option {
      margin: auto;
      cursor: pointer;
      .cancel-button {
        padding: 10px;
        border-radius: 50%;
        @include trans-all;
        &:hover {
          background: $grey4;
          color: $cPrimary;
        }
      }
    }
  }
}

.ellipsis-text {
  max-width: 100%;
  word-break: unset;
  display: -webkit-box;
  max-height: 3.2rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
}
</style>
